import { render, staticRenderFns } from "./drawlottery.vue?vue&type=template&id=2b72a812&scoped=true"
import script from "./drawlottery.vue?vue&type=script&lang=js"
export * from "./drawlottery.vue?vue&type=script&lang=js"
import style0 from "./drawlottery.vue?vue&type=style&index=0&id=2b72a812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72a812",
  null
  
)

export default component.exports